///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2021, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2021 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////
/* eslint-disable no-unused-vars */
import { Viewer } from "../Viewer";
import { OrbitAction } from "./Actions/OrbitAction";
import { Point2d } from "./Common/Geometry";
import { OdBaseDragger } from "./Common/OdBaseDragger";

export class OdOrbitDragger extends OdBaseDragger {
  private _orbitAction: OrbitAction;
  protected m_viewCenter: any;
  protected m_startPoint: Point2d;
  protected startCameraParams: any;

  constructor(subject: Viewer) {
    super(subject);
    this.autoSelect = true;
    this.press = false;
    this._orbitAction = new OrbitAction(this.m_module, this.subject, this.beginInteractivity, this.endInteractivity);
  }

  override start(x: number, y: number): void {
    this.press = true;
    this._orbitAction.beginAction(x, y);
  }

  setDefaultViewParams(): void {
    const extView = this.getViewer().getActiveTvExtendedView();
    extView.setView(
      this.startCameraParams.position,
      this.startCameraParams.target,
      this.startCameraParams.upVector,
      this.startCameraParams.viewFieldWidth,
      this.startCameraParams.viewFieldHeight,
      this.startCameraParams.perspective
    );
    extView.delete();
  }

  override drag(x: number, y: number, dltX: number, dltY: number): void {
    if (this.press) {
      this._orbitAction.action(x, y);
    }
  }

  override end(): void {
    this.press = false;
    this._orbitAction.endAction();
  }
}
